import { render } from "./HoolduskavaLeht.vue?vue&type=template&id=2da47ddb&scoped=true&ts=true"
import script from "./HoolduskavaLeht.vue?vue&type=script&lang=ts"
export * from "./HoolduskavaLeht.vue?vue&type=script&lang=ts"

import "./HoolduskavaLeht.vue?vue&type=style&index=0&id=2da47ddb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da47ddb"]])

export default __exports__